export enum ProductionScheduleItemInPathGroupStatus {
  CHANGED,
  ADDED,
  REMOVED,
  NORMAL
}
